'use client';

import { forwardRef } from 'react';

import { Textarea as MantineTextArea, type TextareaProps } from '@mantine/core';

export interface ITextArea extends TextareaProps {
  error?: string;
  dataTestId?: string;
}

export const TextArea = forwardRef<HTMLTextAreaElement, ITextArea>(
  ({ placeholder, label, description, minRows, maxRows, maxLength, error, dataTestId, ...props }, ref) => (
    <>
      <MantineTextArea
        ref={ref}
        placeholder={placeholder}
        data-testid={dataTestId}
        label={label}
        description={description}
        error={!!error}
        autosize={true}
        minRows={minRows}
        maxRows={maxRows}
        maxLength={maxLength}
        {...props}
      />
      {error && <span className="text-accent-red">{error}</span>}
    </>
  ),
);

TextArea.displayName = 'TextArea';
